import React from "react";
import BackgroundManager from './BackgroundManager';

import { IoHome } from "react-icons/io5";
// import UploadCSV from "../UploadCSV/UploadCSV";
import { useNavigate } from "react-router-dom";
import UploadCSV from "../UploadCSV/UploadCSV";
import { GrDocumentCsv } from "react-icons/gr";
import { IoMdPhotos } from "react-icons/io";

import "./AdminPanel.css"

const AdminPanel = () => {
    const navigate = useNavigate();
  
  return (
    <div className="container">
      {/* אייקון חזרה לעמוד הבית */}
      <div className="home-icon" onClick={() => navigate("/")}>
        <IoHome title="עמוד הבית" size={30} />
      </div>
      
      <h2>ניהול קבצי CSV ותמונות רקע</h2>
      <div className="upload-box">
        {/* קטגוריה 1 - משחקים קרובים */}
        <div className="upcoming">
          <h2><GrDocumentCsv className="csv-file" size={26} />המשחקים הקרובים</h2>
          <UploadCSV type="upcoming" />
        </div>

        {/* קטגוריה 2 - משחקי ליגה */}
        <div className="upload-leagueMatches">
          <h2><GrDocumentCsv className="csv-file" size={26} />משחקי ליגה</h2>
          <UploadCSV type="matches"/>
        </div>

        {/* קטגוריה 3 - קובצי דירוג */}
        <div className="rankings">
          <h2><GrDocumentCsv className="csv-file" size={26} />קבצי דירוג</h2>
          <UploadCSV type="ranking"/>
        </div>
        
        {/* העלאת תמונות רקע */}
        <div className="backgrounds">
          <h2><IoMdPhotos className="image-file" size={28} />העלאת תמונות רקע</h2>
          <BackgroundManager />
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
